export const vwSetInfoOnOrder = `
mutation VWSetInfoOnOrder($input: OSOrderInput!) {
  vwSetInfoOnOrder(input: $input)
}`
